import React, { useState, useEffect } from "react";
import axios from "axios";
import { api } from "../context/AuthContext";
import {
  Container,
  Chip,
  Typography,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

function SuperAdminDashboard() {
  const [stats, setStats] = useState({
    users: 0,
    jobs: 0,
    applications: 0,
    revenue: 0,
  });
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const token = localStorage.getItem("token");
        const config = {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        };

        const [statsRes, queriesRes, paymentsRes] = await Promise.all([
          api.get("/super-admin/stats"),
          api.get("/support-queries", {
            headers: {
              'Accept': 'application/json'
            }
          }).catch(() => ({ data: [] })),
          api
            .get("/payment/super-admin/payments")
            .catch(() => ({ data: [] })),
        ]);

        const totalRevenue = paymentsRes.data.reduce(
          (acc, p) => acc + (p.status === "captured" ? p.amount : 0),
          0,
        );

        setStats({
          users: statsRes.data.users,
          jobs: statsRes.data.jobs,
          applications: statsRes.data.applications,
          revenue: totalRevenue / 100,
        });
        setQueries(queriesRes.data);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container sx={{ py: 4 }}>
      <Typography 
        variant="h3"
        gutterBottom
        sx={{ fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' } }}
      >
        Super Admin Dashboard
      </Typography>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ 
            height: '100%',
            borderBottom: '4px solid #4F46E5',
            '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 8px 24px rgba(79,70,229,0.15)' },
            transition: 'all 0.3s ease'
          }}>
            <CardContent>
              <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 500, mb: 1 }}>Total Users</Typography>
              <Typography variant="h4" sx={{ fontWeight: 700, fontSize: { xs: '2rem', md: '3rem' } }}>{stats.users}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ 
            height: '100%',
            borderBottom: '4px solid #4F46E5',
            '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 8px 24px rgba(79,70,229,0.15)' },
            transition: 'all 0.3s ease'
          }}>
            <CardContent>
              <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 500, mb: 1 }}>Total Jobs</Typography>
              <Typography variant="h4" sx={{ fontWeight: 700, fontSize: { xs: '2rem', md: '3rem' } }}>{stats.jobs}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ 
            height: '100%',
            borderBottom: '4px solid #4F46E5',
            '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 8px 24px rgba(79,70,229,0.15)' },
            transition: 'all 0.3s ease'
          }}>
            <CardContent>
              <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 500, mb: 1 }}>Applications</Typography>
              <Typography variant="h4" sx={{ fontWeight: 700, fontSize: { xs: '2rem', md: '3rem' } }}>{stats.applications}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ 
            height: '100%',
            borderBottom: '4px solid #4F46E5',
            '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 8px 24px rgba(79,70,229,0.15)' },
            transition: 'all 0.3s ease'
          }}>
            <CardContent>
              <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 500, mb: 1 }}>Total Revenue</Typography>
              <Typography variant="h4" sx={{ fontWeight: 700, fontSize: { xs: '2rem', md: '3rem' } }}>₹{stats.revenue}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default SuperAdminDashboard;
